<template>
  <div v-if="hasPermission">
    <!-- 插槽用于放置需要根据权限显示的内容 -->
    <slot></slot>
  </div>
</template>

<script>
import { can } from "@/utils/permissions";
import { mapGetters } from "vuex";
export default {
  name: "PermissionChecker",
  props: {
    permission: {
      type: String,
      required: true,
    },
    userPermissions: {
      type: Array,
      required: false,
    },
  },
  computed: {
    ...mapGetters(["user"]),
    hasPermission() {
      //console.info("user", this.user);
      const forumAdmin = this.user.forumAdmin ? this.user.forumAdmin : false;
      if (forumAdmin) {
        return true;
      }

      const userPermissions = this.userPermissions
        ? this.userPermissions
        : this.user.perms;
    //  console.info("perms", userPermissions);
      return can(this.permission, userPermissions);
    },
  },
};
</script>
